<div class="content" *ngIf="evaluationResponse">
  <!-- [(ngModel)]="useRandomServiceLevelAssignment" -->

  <div class="group" *ngFor="let evaluation of evaluationResponse.evaluations; let i = index;">
    <div class="group-content">
      <div class="group-left-content">
        <div class="group-avatar"[style.background-color]="getColorFromName(evaluation.providerKey)">{{(evaluation.providerKey).substring(0,1)}}</div>
        <div class="group-text">
          <div class="group-name">{{evaluation.providerKey}} / {{evaluation.evaluationAmt}} {{evaluation.evaluationUnit}} <span *ngIf="evaluation.perPatientFlag == 1">(Patient-specific)</span>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <button  (click)="editEvaluation(i)" mat-icon-button >
          <mat-icon>edit_outline</mat-icon>
        </button>
        <button *ngIf="!evaluationResponse.familyCount || evaluationResponse.familyCount === null || evaluationResponse.familyCount === 0" (click)="deleteEvaluation(i)" mat-icon-button >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>

  </div> 
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="editEvaluation(-1)">
  + Add new
    </button>
  </div> 
</div>
